import {useState, useEffect} from 'react'; 
const useFetch = (url)=>{

    const [data, setData] = useState(null);
    const [isPending, setIsPending] = useState(true); 
    const [error, setError] = useState(null);


    useEffect(()=>{
        const abortCont = new AbortController();

        setTimeout(() => {
         fetch(url,{signal: abortCont.signal})
             .then(res => {
                 if(!res.ok){
                     throw Error('could not fetch the data for that resource');
                 }
                 return res.json();
             })
             .then(data => {  //this data is local version of data that not gonna effect the global data variable
                 setData(data);
                 setIsPending(false);
                 setError(null);
             })
             .catch( err =>{
                if(err.name ==='AbortError'){
                    console.log('Fetch aborted')
                }
                else{
                    setIsPending(false);
                    setError(err.message);
                }
                 
             }) 
        }, 1000);
       return () => abortCont.abort();
     }, [url]); 

     return {data, isPending, error}
}

export default useFetch

// route parameter is like variable inside a route